<div class="nothing-to-search">
  <div class="search-logo">🔍</div>
  <div class="search-title" translate="search/nothing-to-search/title"></div>
  <div class="search-description" [innerHtml]="'search/nothing-to-search/description' | translate"></div>
  <div
    cdkOverlayOrigin
    #trigger
    class="restart-feature-tour"
    translate="search/nothing-to-search/restart-feature-tour"
    (click)="startTour()"></div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="popoverDisplayed"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayOffsetX]="0"
  [cdkConnectedOverlayOffsetY]="0">
  <div class="feature-tour-step-container position-center">
    <app-step-popover
      [titleKey]="'search/feature-tour/start/title'"
      [descriptionKey]="'search/feature-tour/start/description'"
      [nextKey]="'search/feature-tour/start/start-tour'"
      [previousKey]="'search/feature-tour/skip'"
      (next)="featureTourService.setFeatureStep(FeatureTourStepEnum.SEARCH_BAR)"
      (previous)="featureTourService.setFeatureStep(null)"></app-step-popover>
  </div>
</ng-template>
